import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpChartLegendComponent from './adpChartLegend.component';

let adpChartLegendModule = angular.module('adpChartLegend', [
  uiRouter
])

.component('adpChartLegend', adpChartLegendComponent)

.name;

export default adpChartLegendModule;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegend/adpChartLegend.js